import ActiveLocations from './ActiveLocations';

export default ActiveLocations;
